export default {
  category: 'book',
  name: 'Big Bets',
  author: 'Rajiv Shah',
  date: '2/25/24',
  path: '/notes/big-bets',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-big-bets-rajiv-shah.jpg',
  tags: ['Business', 'Leadership'],
  time: 7,
  rating: 3.8,
  review: '',
  link: 'https://www.amazon.com/Big-Bets-Large-Scale-Change-Happens/dp/1668004380',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.TwosApp.com/65b70508e8d9812ac8e7a471',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
